"use client";

import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { useAuth } from "@/hooks/use-auth";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { useSidebar } from "../../stores/sidebar.atoms";
import { SignUpSidebarContent } from "./signup-sidebar.content";

export const SignUpSidebar = () => {
    const [sidebar, setSidebar] = useSidebar();

    const { cancelSignIn } = useAuth();

    return (
        <Sheet
            open={sidebar.open}
            onOpenChange={(open) => {
                if (!open) {
                    setSidebar({ open });
                    cancelSignIn();
                }
            }}
        >
            <SheetContent
                className="w-full sm:max-w-md"
                onInteractOutside={(e) => {
                    e.preventDefault();
                }}
            >
                <VisuallyHidden.Root>
                    <SheetTitle>Sign Up Sidebar</SheetTitle>
                </VisuallyHidden.Root>
                {sidebar.open && (
                    <SignUpSidebarContent
                        relativeRedirectUrl={sidebar?.relativeRedirectUrl}
                        sidebarType={sidebar.type}
                        onSidebarTypeChange={(type) => {
                            setSidebar((prev) => ({
                                ...prev,
                                type,
                            }));
                        }}
                    />
                )}
            </SheetContent>
        </Sheet>
    );
};
